// src/i18n.js
export function gettext(message) {
    if (window.gettext) {
        return window.gettext(message);
    }
    return message;
}

export function interpolate(message, ...args) {
    if (window.interpolate) {
        return window.interpolate(message, ...args);
    }
    return message.replace(/%s/g, () => args.shift() || '%s');
}

export function ngettext(singular, plural, count) {
    if (window.ngettext) {
        return window.ngettext(singular, plural, count);
    }
    return count === 1 ? singular : plural;
}

export function pgettext(context, message) {
    if (window.pgettext) {
        return window.pgettext(context, message);
    }
    return message;
}

export function npgettext(context, singular, plural, count) {
    if (window.npgettext) {
        return window.npgettext(context, singular, plural, count);
    }
    return count === 1 ? singular : plural;
}
